import { ChevronLeft, ChevronRight } from "lucide-react";
import DatePicker, {
  ReactDatePickerCustomHeaderProps,
  ReactDatePickerProps,
} from "react-datepicker";
import { cn } from "~/lib/utils";

import { buttonVariants } from "./button";

function CustomCaption({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps) {
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  return (
    <>
      <div className="relative flex items-center justify-between px-2 py-0 font-Medium">
        <span className="text-xl">
          {month} {year}
        </span>
        <div>
          <button
            type="button"
            onClick={decreaseMonth}
            className={cn(
              buttonVariants({ variant: "ghost" }),
              "h-7 w-7 bg-transparent p-0 hover:opacity-100",
            )}
            aria-label="Previous Month"
            disabled={prevMonthButtonDisabled}
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button
            type="button"
            onClick={increaseMonth}
            className={cn(
              buttonVariants({ variant: "ghost" }),
              "h-7 w-7 bg-transparent p-0",
            )}
            aria-label="Next Month"
            disabled={nextMonthButtonDisabled}
          >
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
      <hr className="bg-neutral-200" />
    </>
  );
}
export const DateTimePicker = (props: ReactDatePickerProps) => {
  return (
    <DatePicker
      {...props}
      preventOpenOnFocus
      renderCustomHeader={CustomCaption}
    />
  );
};
